export default "__VITE_ASSET__oAFkVtOU__"